import { Fragment, memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';
import { unlimitedJokerSids } from '../../utils/casinoUtils';
import Collapse from '../Collapse';

const JOKER_IMG_BASE = 'https://wver.sprintstaticdata.com/v230/static/front/img/joker1';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function formatAmount(n) {
  const num = Number(n) || 0;
  if (num >= 100000) return `${num / 100000}L`;
  if (num >= 1000) return `${num / 1000}K`;
  return String(num);
}

function bookOf(exposures, sid) {
  const v = exposures?.[`sid:${sid}`];
  return v ? roundBook(v) : 0;
}

function bookCls(v) {
  if (!v) return 'book-black';
  return v < 0 ? 'book-red' : 'book-green';
}

// Unlimited Joker (joker120) — admin reference: 14 static A/B row pairs.
// Sids: A = N (10th pair -> 101), B = N*10 (10th -> 100); sub[] me sirf
// active round ka pair aata hai (subtype jokerno, Fancy), baaki rows
// suspended 0 dikhti hain. A row ke nation-name me joker1/N.png image,
// B row me image slot khali.
const PAIRS = Array.from({ length: 14 }, (_, i) => ({ n: i + 1, ...unlimitedJokerSids(i + 1) }));

// mirrorFeedPair (Unlimited Joker 20-20): the feed quotes only the no-joker
// pair, but every joker is played at the same odds — a row with no feed item of
// its own copies the feed's Player A / B status and odds, so it is open while the
// round is open (user 2026-10-14; they were always locked).
const BetTableJoker120 = memo(function BetTableJoker120({ gameData, onBet, exposures, footer = null, mirrorFeedPair = false }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const [openRanges, setOpenRanges] = useState({});
  const toggle = (id) => setOpenRanges((p) => ({ ...p, [id]: !p[id] }));

  const bySid = (sid) => sub.find((s) => Number(s.sid) === sid);
  const feedOf = (label) => (mirrorFeedPair ? sub.find((s) => s.nat === label) : undefined);

  const row = (label, sid, img) => {
    const item = bySid(sid) || feedOf(label);
    const book = bookOf(exposures, sid);
    const rid = `range${sid}`;
    return (
      <div className="casino-box-row">
        <div className="casino-nation-name">
          {img ? <img src={img} /> : null}
          {' '}
          <b>{label}</b>
          {' '}
          <div className="float-right">
            <span className={`mr-2 ${bookCls(book)}`}>{fmtBook(book)}</span>
            {' '}
            <i
              data-toggle="collapse"
              data-target={`#${rid}`}
              aria-expanded={openRanges[rid] ? 'true' : 'false'}
              className={`fas fa-info-circle${openRanges[rid] ? '' : ' collapsed'}`}
              onClick={() => toggle(rid)}
              style={{ cursor: 'pointer' }}
            ></i>
            {' '}
            <Collapse id={rid} open={openRanges[rid]} className="icon-range">
              {'\n                        R:'}
              <span>{formatAmount(item?.min ?? 100)}</span>
              -
              <span>{formatAmount(item?.max ?? 300000)}</span>
            </Collapse>
          </div>
        </div>
        {' '}
        <div className="casino-bl-box">
          <div
            className={`back casino-bl-box-item${suspCls(item)}`}
            onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}
          >
            <span className="casino-box-odd">{item?.b || 0}</span>
          </div>
          {' '}
          <div
            className={`lay casino-bl-box-item${suspCls(item)}`}
            onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}
          >
            <span className="casino-box-odd">{item?.l || 0}</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="teen1daycasino-container mt-2">
      <div className="teen1dayleft">
        {PAIRS.map(({ n, sidA, sidB }) => (
          <Fragment key={n}>
            {row('Player A', sidA, `${JOKER_IMG_BASE}/${n}.png`)}
            {row('Player B', sidB, null)}
          </Fragment>
        ))}
      </div>
      {' '}
      <div className="teen1daycenter"></div>
      {' '}
      {/* mobile pe last-results strip yahan (teen1daycasino-container ke andar) */}
      {footer}
    </div>
  );
});

export default BetTableJoker120;
